import { SpinnerDiv } from "../spinner/spinnerDiv"

type Props = {
  ready: boolean
  children: JSX.Element
}

export const DetailLoader = (props: Props) => {
  const { ready, children } = props
  return ready ? children : <SpinnerDiv />
}
